import { Component, inject, Signal, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { DynamicDialogConfig, DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { InputTextModule } from "@openng/optimus-ui/inputtext";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { RolesService } from "../../../../services/api/roles/roles.service";

import { toSignal } from "@angular/core/rxjs-interop";
import { Role } from "../../../../models/api/role";
import { DropdownOption } from "../../../../models/ui/dropdownOption";
import { WIKI_ACCESS_LEVEL_OPTIONS } from "../../../../constants/wikiAccessLevelOptions";
import { SelectModule } from "@openng/optimus-ui/select";

@Component({
  standalone: true,
  selector: "app-user-form",
  imports: [ButtonComponent, ReactiveFormsModule, InputTextModule, SelectModule, TranslateModule],
  templateUrl: "./user-form.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./user-form.component.scss",
})
export class UserFormComponent {
  private config = inject(DynamicDialogConfig);
  private formFields = this.config.data.formFields;
  private actionType: "edit" | "add" = this.config.data.actionType;
  private tenantId = this.config.data.tenantId;
  private customerId = this.config.data.customerId;

  public form = new FormGroup({
    email: new FormControl({ value: this.formFields.email, disabled: this.actionType === "edit" }, Validators.required),
    firstName: new FormControl(this.formFields.firstName, Validators.required),
    lastName: new FormControl(this.formFields.lastName, Validators.required),
    role: new FormControl(this.formFields.role, Validators.required),
    faultListPermission: new FormControl(this.formFields.faultListPermission, Validators.required),
  });
  private ref = inject(DynamicDialogRef);
  public translate = inject(TranslateService);
  private rolesService = inject(RolesService);
  public roles: Signal<Role[] | undefined> = toSignal(this.rolesService.getRoles(this.tenantId, this.customerId));
  public wikiLevelOptions: DropdownOption[] = WIKI_ACCESS_LEVEL_OPTIONS;

  /**
   * Saves the user data by extracting it from the form,
   *  updating the role value if present, and then closing the dialog.
   */
  public save() {
    const user = this.form?.getRawValue();
    this.ref.close(user);
  }
  /**
   * Closes the dialog.
   */
  public closeDialog() {
    this.ref.close();
  }
}
